import { Component, ViewEncapsulation } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { DynamicDialogModule, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { AuthService } from '../../_services';
import { SpinnerService } from '../spinner/spinner.service';

@Component({
  selector: 'app-session-expired-session-expired-dialog',
  templateUrl: './session-expired-dialog.component.html',
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [TranslateModule, DynamicDialogModule],
})
export class SessionExpiredDialogComponent {
  wrongInput: boolean = false;

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private auth: AuthService,
    private spinner: SpinnerService
  ) {
  }

  signIn() {
    this.spinner.show();
    this.auth.SignIn()
      .then((result) => {
        if(result?.user)
          return result.user.getIdToken();
        else // Go to catch error
          throw new Error("Token non presente");
      })
      .then((result2) => {
          this.spinner.hide();
          this.getInfoUser(result2);
      }).catch(err => {
        console.log(err);
        this.spinner.hide();
        this.wrongInput = true;
    });
  }

  async getInfoUser(idToken: string){
    this.spinner.show();
    this.auth.login(idToken).subscribe({
      next: (res) => {
        this.spinner.hide();
        this.auth.setUserInfo(res,idToken);
        this.ref.close(res)
      },
      error: (err) => {
        console.log(err);
        this.spinner.hide();
        this.wrongInput = true;
      },
    });
  }
}
